import { useEffect, useState } from "react";
import VirtualTable from "../../../components/custom/VirtualTable";
import { AppUnit } from "../../../globals/interfaces";
import apiClient from "../../../apiClient";
import ModalManage from "./ModalManage";
import { useAppContext } from "../../../context";
import { notify } from "../../../utils";
import _ from "lodash";

export type UpdateApp = (values: AppUnit) => Promise<void>;

export default function ManageApps ({
    activeTab
}: {
    activeTab: string;
}) {

    const { user } = useAppContext();
    const [apps, setApps] = useState<Array<AppUnit>>([]);
    const [modal, setModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState<AppUnit>();

    useEffect(() => {
        const getApps = async () => {
            try {
                const res = await apiClient.get(`/dev/desktop-apps`);
                setApps(res.data);
            } catch (err) {}
        }
        if (activeTab === 'manageApps') {
            getApps();
        }
    }, [activeTab]);

    const launchUpdate = (item: AppUnit) => {
        setSelectedItem(item);
        setModal(true);
    }

    const updateApp = async (values: AppUnit) => {
        if (!selectedItem) return;
        await apiClient.put(`/dev/desktop-apps/${selectedItem.appId}`, values);
        setApps(prev => {
            const copy = _.cloneDeep(prev);
            const updateId = copy.findIndex(item => item.appId === selectedItem.appId);
            copy[updateId] = values;
            return copy;
        });
        setModal(false);
        notify('Updated');
    }


    return (
        <div>
            <VirtualTable 
                data={apps}
                mapping={[{
                    name: 'Unit',
                    value: 'unit'
                }, {
                    name: 'Name',
                    value: 'appName'
                }, {
                    name: 'Type',
                    value: 'appType'
                }, {
                    name: 'Display',
                    value: 'displaySetting'
                }, {
                    name: 'Modified at',
                    value: 'modifiedAt',
                    datetime: true,
                    utc: true
                }, {
                    name: 'Modified by',
                    value: 'modifiedBy',
                    email: true
                }]}
                handleClick={launchUpdate}
            />
            <ModalManage 
                modal={modal}
                setModal={setModal}
                item={selectedItem}
                updateApp={updateApp}
                user={user}
            />
        </div>
    );
}

